import { render } from "./Repos.vue?vue&type=template&id=b80fb036"
import script from "./Repos.vue?vue&type=script&lang=js"
export * from "./Repos.vue?vue&type=script&lang=js"
script.render = render

export default script